var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 5C1.875 4.33696 2.13839 3.70107 2.60723 3.23223C3.07607 2.76339 3.71196 2.5 4.375 2.5H15.625C16.288 2.5 16.9239 2.76339 17.3928 3.23223C17.8616 3.70107 18.125 4.33696 18.125 5V15C18.125 15.663 17.8616 16.2989 17.3928 16.7678C16.9239 17.2366 16.288 17.5 15.625 17.5H4.375C3.71196 17.5 3.07607 17.2366 2.60723 16.7678C2.13839 16.2989 1.875 15.663 1.875 15V5ZM5.18333 5.80833C5.30052 5.69129 5.45937 5.62555 5.625 5.62555C5.79063 5.62555 5.94948 5.69129 6.06667 5.80833L7.94167 7.68333C8.05871 7.80052 8.12445 7.95937 8.12445 8.125C8.12445 8.29063 8.05871 8.44948 7.94167 8.56667L6.06667 10.4417C5.94819 10.5521 5.79148 10.6122 5.62956 10.6093C5.46765 10.6065 5.31316 10.5409 5.19865 10.4264C5.08414 10.3118 5.01854 10.1574 5.01569 9.99543C5.01283 9.83352 5.07293 9.67681 5.18333 9.55833L6.61667 8.125L5.18333 6.69167C5.06629 6.57448 5.00055 6.41563 5.00055 6.25C5.00055 6.08437 5.06629 5.92552 5.18333 5.80833ZM8.75 9.375C8.58424 9.375 8.42527 9.44085 8.30806 9.55806C8.19085 9.67527 8.125 9.83424 8.125 10C8.125 10.1658 8.19085 10.3247 8.30806 10.4419C8.42527 10.5592 8.58424 10.625 8.75 10.625H11.25C11.4158 10.625 11.5747 10.5592 11.6919 10.4419C11.8092 10.3247 11.875 10.1658 11.875 10C11.875 9.83424 11.8092 9.67527 11.6919 9.55806C11.5747 9.44085 11.4158 9.375 11.25 9.375H8.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.f950ebe367ac2b346ef870b0a29ce8f2.svg";
export { ForwardRef as ReactComponent };